 /**
 * 操作权限处理 
 */

import Vue from 'vue'
const hasPermi = {
  state: {
    hasPermiInfo: null
  },
  actions: {
    setHasPermiData: function (context, hasPermiInfo) {
      context.state.hasPermiInfo = hasPermiInfo
      // 注册全局授权操作信息
      let hasPermiInfoCodes = hasPermiInfo
      Vue.prototype.authorize = {
        home: {
          edit: hasPermiInfoCodes.includes('HOMEEDIT')
        }
      }
    }
  }
}

export default hasPermi
